<app-spinner-container [isLoading]="ondelete">
    <table

            [dataSource]="dataSource"
            mat-table
            matSort
            style="width: 100%"
    >
        <ng-container *ngFor="let column of readColumns" [matColumnDef]="column">
            <th *matHeaderCellDef mat-header-cell mat-sort-header translate>
                {{ labels[column] | translate }}
            </th>
            <td *matCellDef="let type" mat-cell translate>
                {{ type[column] | typedValue | async | translate}}
            </td>
        </ng-container>

        <tr *matHeaderRowDef="displayedColumns" mat-header-row></tr>
        <tr *matRowDef="let row; columns: displayedColumns" mat-row></tr>
    </table>
    <app-empty-list-container
            [list]="dataSource.data"
            [withoutBorder]="true"
    ></app-empty-list-container>
</app-spinner-container>
